"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTIONS = void 0;
var SECTIONS = {
    GENERAL: 'general',
    PLAYER: 'player',
    STREAMING: 'streaming',
    SHORTCUTS: 'shortcuts',
    HOME_SCREEN: 'home_screen',
    DATA_ENRICHMENT: 'data_enrichment',
};
exports.SECTIONS = SECTIONS;
